<script setup lang="ts">
  import { computed, onMounted, onUnmounted, ref } from 'vue';
  import {
    loadingTypeToSpinnerSizeMap,
    type Props,
  } from '@/components/common/ElLoading/elLoadingPanel';

  defineOptions({ name: 'ElLoadingPanel' });

  const { iconSize = 'default', labelRenderingDelay, label, iconColor = 'blue', align = 'center', justify = 'center', classes } = defineProps<Props>();

  const textTimeout = ref<number>();
  const renderLabel = ref<boolean>(false);

  const positionStyleAttr = computed<{ style: string }>(() => {
    const alignPosition = {
      top: 'top: 5%;',
      center: 'top: 50%;',
      bottom: 'bottom: 5%;',
    };
    const justifyPosition = {
      left: 'left: 5%;',
      center: 'left: 50%;',
      right: 'right: 5%;',
    };

    const transform = `transform: translate(${justify === 'center' ? '-50%' : 0}, ${align === 'center' ? '-50%' : 0})`;

    return { style: `${alignPosition[align]} ${justifyPosition[justify]} ${transform}` };
  });

  onMounted(() => {
    textTimeout.value = window.setTimeout(() => {
      renderLabel.value = true;
    }, labelRenderingDelay);
  });

  onUnmounted(() => {
    clearTimeout(textTimeout.value);
    renderLabel.value = false;
  });
</script>

<template>
  <div
    class="el-loading-panel absolute inset-0 z-10"
    :class="classes?.wrapper"
  >
    <div
      v-bind="positionStyleAttr"
      class="absolute flex size-fit flex-col items-center justify-center gap-4 text-center"
    >
      <div
        class="animate-loading-fade-in"
        :class="classes?.animateLoading ?? ''"
      >
        <div
          class="loading-spinner relative animate-spin rounded-full"
          :class="iconColor"
          :style="{'--loader-size': `${loadingTypeToSpinnerSizeMap[iconSize]}px`}"
        />
      </div>
      <template v-if="label">
        <span
          :class="{'invisible': !renderLabel }"
          :aria-label="label"
        >{{ label }}</span>
      </template>
    </div>
  </div>
</template>
